export default {"src":"/_next/static/media/tj.f4a537db.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};